import {
  DROP_IN_TYPE,
  ModalOpenContextBuilder,
  ModalOpenContext,
  FluentAssignMethod,
  arrayUnion
} from 'angular2-modal';

const /** @type {?} */ DEFAULT_SETTERS = [
  'promptDefault'
];
export class JSNativeModalContext extends ModalOpenContext {
  promptDefault: string;
  dialogType: DROP_IN_TYPE;
/**
 * @return {?}
 */
normalize(): void {
    if (!this.message) this.message = '';
    if (this.dialogType === undefined) this.dialogType = DROP_IN_TYPE.alert;
  }
}

function JSNativeModalContext_tsickle_Closure_declarations() {
/** @type {?} */
JSNativeModalContext.prototype.promptDefault;
/** @type {?} */
JSNativeModalContext.prototype.dialogType;
}

export class JSNativeModalContextBuilder<T extends JSNativeModalContext>
extends ModalOpenContextBuilder<T> {
/**
 * The default value for the prompt input
 */
promptDefault: FluentAssignMethod<string, this>;
/**
 * @param {?=} defaultValues
 * @param {?=} initialSetters
 * @param {?=} baseType
 */
constructor(defaultValues: T = undefined,
              initialSetters: string[] = undefined,
              baseType: new () => T = undefined) {
    super(
      defaultValues || <any>{},
      arrayUnion<string>(DEFAULT_SETTERS, initialSetters || []),
      baseType || <any>JSNativeModalContext
      // https://github.com/Microsoft/TypeScript/issues/7234
    );
  }
}

function JSNativeModalContextBuilder_tsickle_Closure_declarations() {
/**
 * The default value for the prompt input
 * @type {?}
 */
JSNativeModalContextBuilder.prototype.promptDefault;
}

